var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AudienceNotesPanel',{attrs:{"content-id":_vm.id,"view":_vm.view}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }